import { GetAllOrganizer } from '~/domain/usecases/organizer/redux';
import {
  iActionGetAll,
  iActionGetAllSuccess,
  iActionGetAllFailed,
  OrganizerTypes,
} from '~/domain/interfaces/redux/Organizer/getAll';

export const getAllRequest = (
  payload: GetAllOrganizer.Params,
): iActionGetAll => ({
  type: OrganizerTypes.GETALL,
  payload,
});

export const getAllSuccess = (
  params: GetAllOrganizer.Model,
): iActionGetAllSuccess => ({
  type: OrganizerTypes.GETALL_SUCCESS,
  payload: params,
});

export const getAllFailed = (): iActionGetAllFailed => ({
  type: OrganizerTypes.GETALL_FAILED,
});
